import { render, staticRenderFns } from "./homeScrapingView.vue?vue&type=template&id=dfb452be"
import script from "./homeScrapingView.vue?vue&type=script&lang=ts"
export * from "./homeScrapingView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports